<template>
  <!-- List Group start-->
  <div>
    <!-- top section of the list group conatins group name section and connfig group permission-->
    <div class="row">
      <!-- Group name section starts-->
      <div class="col-8">
        <div class="card">
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>
                  <label class="sub_heading group_name">Group Name</label>
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter Group Name"
                    class="grp_box"
                    name="group_name"
                    v-model="group.name"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label class="sub_heading group_name new_margin"
                    >Description</label
                  >
                </td>
                <td>
                  <textarea
                    placeholder
                    class="grp_box box_width"
                    name="description"
                    rows="10"
                    cols="60"
                    style="resize: none"
                    v-model="group.description"
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <label class="sub_heading group_name">Commodities</label>
                </td>
                <td class="row" style="margin: 0">
                  <!-- <div class="form-check col-6">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="setAllCommodity"
                      id="potato_comm"
                    />
                    <label class="form-check-label" for="potato_comm">All</label>
                  </div> -->
                  <!-- <div
                    class="form-check col-6"
                    v-for="commodity,index in allCommodity"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value
                      :id="commodity.name+'_comm'"
                      :disabled="setAllCommodity"
                      v-model="commodity.status"
                    />
                    <label class="form-check-label" :for="commodity.name+'_comm'">{{commodity.name}}</label>
                  </div> -->
                  <div
                    class="form-check col-6"
                    v-for="(commodity, index) in allCommodity"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="commodity.name"
                      :value="commodity.name"
                      v-model="picked"
                    />
                    <label class="form-check-label" :for="commodity.name">{{
                      commodity.name
                    }}</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-right"></td>
                <td>
                  <button class="add" @click="CancelEdit">Cancel</button>
                  <button
                    class="add"
                    v-if="noEditFlag"
                    @click="DeleteGroup"
                    style="width: 88px"
                  >
                    Delete Group
                  </button>

                  <button class="add" v-if="noEditFlag" @click="AddGroup">
                    Update
                  </button>
                  <button class="add" v-else @click="AddGroup">Add</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="list-group col-4" v-if="noEditFlag">
        <div class="list-group-item active card-header">
          Users assocaiated to the Group
        </div>
        <div
          class="list-group-item list-group-item-action"
          v-for="user in group.users"
          :key="user.id"
        >
          {{ user.username }}
          <span class="float-right remove-tag" @click="removeUser(user)"
            >remove</span
          >
        </div>
      </div>
      <!-- group name section ends here-->
      <!-- config group section ends here-->
    </div>
  </div>
  <!-- group user body end here-->
</template>

<script>
export default {
  name: "EditGroup",
  data() {
    return {
      //it send group to the assigned user nad unassigned user
      group: {
        name: "",
        description: "",
      },
      setAllCommodity: false,
      allCommodity: [],
      picked: null,
    };
  },
  computed: {
    commodities() {
      return this.$store.state.Commodities;
    },
    noEditFlag() {
      return this.$route.path.includes("/edit/");
    },
  },
  watch: {
    setAllCommodity(val) {
      if (val) {
        this.allCommodity.forEach((element, key) => {
          // console.log(key);
          this.allCommodity[key].status = true;
        });
      } else {
        this.allCommodity.forEach((element, key) => {
          // console.log(key);
          this.allCommodity[key].status = false;
        });
      }
    },
  },
  methods: {
    async configurecommodity() {
      var allCommodity = this.allCommodity;
      await this.commodities.Vegetables.forEach((element) => {
        allCommodity.push({ name: element, status: false });
      });
      await this.commodities.Fruits.forEach((element) => {
        allCommodity.push({ name: element, status: false });
      });

      this.allCommodity = allCommodity;
      console.log('edit', this.noEditFlag)
      if (this.noEditFlag) {
        await this.allCommodity.forEach((element, key) => {
            if (this.group.commodities.includes(element.name)) {
              this.allCommodity[key].status = true;
              this.picked = element.name;
            }
          });
        // if (this.group.commodities.length == this.allCommodity.length) {
        //   this.setAllCommodity = true;
        // } else {
        //   await this.allCommodity.forEach((element, key) => {
        //     if (this.group.commodities.includes(element.name)) {
        //       this.allCommodity[key].status = true;
        //       this.picked = element.name;
        //     }
        //   });
        // }
      }
    },
    setAllCommodities(val) {
      if (this.setAllCommodity) {
        this.allCommodity.forEach((element, key) => {
          // console.log(key);
          this.allCommodity[key].status = true;
        });
      }
    },
    async AddGroup(obj) {
      if (this.group.name == "" || this.group.description == "") {
        this.$store.dispatch("showSnackbar", {
          msg: "Name and description is important",
        });
        return;
      }
      var commodities = [];
      commodities.push(this.picked);
      // await this.allCommodity.forEach((element, key) => {
      //   if (this.allCommodity[key].status) {
      //     commodities.push(this.allCommodity[key].name);
      //   }
      // });
      if (commodities.length < 1) {
        this.$store.dispatch("showSnackbar", { msg: "No Commodity Selected!" });
        return;
      }
      var group = {
        ...this.group,
        commodities,
      };
      delete group.users;

      if (this.noEditFlag) {
        delete group.created;
        delete group.lastUpdated;
        var logData = this.createLogData(group, "edit");
        await this.$store.dispatch("updateCGroup", group);
        await this.$store.dispatch("AddUserLog", logData);
      } else {
        group.creator = this.$store.state.username;
        var logData = this.createLogData(group, "create");
        await this.$store.dispatch("addCGroups", group);
        logData.record = this.$store.state.editGroupId;
        await this.$store.dispatch("AddUserLog", logData);
      }
      this.$router.push("/app/secure/group/all");
    },
    async removeUser(user) {
      var r = confirm(`remove ${user.username} from the group?`);
      if (r) {
        this.$store.dispatch("showLoader", true);
        try {
          await this.$store.dispatch("removeUserFromCGroup", {
            uid: user.id,
            cid: this.$store.state.editGroupId,
          });
          await this.$store.dispatch(
            "getCGroup",
            this.$store.state.editGroupId
          );

          const logdata = {
            user: this.$store.state.user,
            collection: "user",
            mode: "edit",
            record: user.id,
            fields: ["cmdGroups"],
            newValue: [],
            oldValue: [this.$store.state.editGroupId],
          };
          await this.$store.dispatch("AddUserLog", logdata);
          this.group = this.$store.state.activeGroup;
          this.$store.dispatch("showSnackbar", {
            msg: "Removed user Successfully",
          });
        } catch (error) {
          console.log("err", error);
          this.$store.dispatch("showSnackbar", { msg: error });
        }
        this.$store.dispatch("showLoader", false);
      }
    },
    async DeleteGroup(e) {
      var r = confirm(`remove all users and delete the group?`);
      if (r) {
        for (let user in this.group.users) {
          try {
            var logdata = {
              user: this.$store.state.user,
              collection: "user",
              mode: "edit",
              record: this.group.users[user].id,
              fields: ["cmdGroups"],
              newValue: [],
              oldValue: [this.$store.state.editGroupId.toString()],
            };
            await this.$store.dispatch("removeUserFromCGroup", {
              uid: this.group.users[user].id,
              cid: this.$store.state.editGroupId,
            });
            await this.$store.dispatch("AddUserLog", logdata);
            this.$store.dispatch("showSnackbar", {
              msg: "Removed user Successfully",
            });
            this.$router.push("/app/secure/group/all");
          } catch (error) {
            this.$store.dispatch("showSnackbar", { msg: error });
          }
        }

        var group = {
          ...this.group,
        };
        delete group.users;
        delete group.lastUpdated;
        delete group.created;
        delete group.creator;
        var logData = this.createLogData(group, "delete");
        await this.$store.dispatch("showLoader", true);
        try {
          await this.$store.dispatch(
            "deleteCGroup",
            this.$store.state.editGroupId
          );
          await this.$store.dispatch("AddUserLog", logData);
          this.$store.dispatch("getCGroups");
        } catch (err) {
          this.$store.dispatch("showSnackbar", { msg: err });
          await this.$store.dispatch("showLoader", false);
        }
      }
    },
    CancelEdit(obj) {
      this.$router.push("/app/secure/group/all");
    },
    createLogData(obj, mode) {
      var group = _.cloneDeep(obj);
      var keys = [],
        oldValue = [],
        newValue = [];
      var LogData = {};
      delete group.users;
      if (mode == "edit") {
        for (let key in group) {
          if (group[key] != this.$store.state.activeGroup[key]) {
            newValue.push(group[key]);
            oldValue.push(this.$store.state.activeGroup[key]);
            keys.push(key);
          }
        }
        // console.log(permissions == this.$store.state.activeGroup.permissions);
        LogData = {
          user: this.$store.state.user,
          collection: "CommodityGroup",
          mode: "edit",
          record: this.$store.state.editGroupId,
          fields: keys,
          newValue,
          oldValue,
        };
      } else if (mode == "create") {
        for (let key in group) {
          newValue.push(group[key]);
          // oldValue.push(null);
          keys.push(key);
        }
        LogData = {
          user: this.$store.state.user,
          collection: "CommodityGroup",
          mode: "create",
          fields: keys,
          newValue,
          oldValue: [],
        };
      } else if (mode == "delete") {
        LogData = {
          user: this.$store.state.user,
          collection: "commodity_group ",
          mode: "delete",
          record: this.$store.state.editGroupId,
          fields: [],
          newValue: [],
          oldValue: [],
        };
        for (let key in group) {
          LogData.fields.push(key);
          LogData.oldValue.push(group[key]);
        }
      }
      // console.log(x`LogData);

      return LogData;
    },
  },
  mounted() {
    //it off the loader
  },
  beforeDestroy() {
    this.$store.commit("getCGroup", {});
  },
  async created() {
    this.$store.commit("changePathLabel", {
      view: "Configure Groups",
      categories: [
        { name: "All Groups", focus: false },
        {
          name: this.noEditFlag ? "Edit Groups" : "Create Groups",
          focus: true,
        },
      ],
    });
    await this.$store.dispatch("getallCommodities");
    if (this.noEditFlag) {
      await this.$store.dispatch("getCGroup", this.$store.state.editGroupId);
      this.group = this.$store.state.activeGroup;
    }
    this.configurecommodity();
    this.$store.dispatch("showLoader", false);
  },
};
</script>

<style scoped>
.card {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding-top: 19px;
  padding-bottom: 19px;
  padding-left: 32px;
  padding-right: 32px;
}

.card-2 {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  /* padding: 40px; */
}
.grp_box {
  width: 231px;
  height: 38px;
  mix-blend-mode: normal;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #b4b4b4;
  padding: 8px 16px;
}
.sub_heading {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #29342e;
}
.group_name {
  margin-right: 24px;
  width: 74px;
}
.new_margin {
  margin-top: 24px;
}
.box_width {
  margin-top: 12px;
  height: 76px;
  width: 385px;
}
.width_new {
  width: 839px;
}
.new_confi {
  font-weight: 600;
  text-align: center;
  background: #f2f2f2;
  border: 1px solid #cacaca;
  box-sizing: border-box;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 42px;
  padding: 12px 26px;
}
.font_wei {
  font-weight: 400;
}
.padd_new {
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  border-top-left-radius: none !important;
  border-top-right-radius: none !important;
}
.right_top_tr {
  height: 30px;
}
.new_card {
  width: 243px;
  height: 389px;
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  margin-right: 48px;
}
.summary {
  height: 36px;
  text-align: center;
  padding-top: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid #cacaca;
}
.list_style {
  height: 40px;
  margin-left: 16px;
  padding-top: 10px;
}
.remove {
  width: 42px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #e74c3c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 13px;
  color: #e74c3c;
  margin-left: 97px;
}
.add {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 13px;
  color: #24c656;
  width: 56px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 97px;
}
.table_top {
  margin-top: 8px;
}
.table_font {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: #29342e;
}
.card2 {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-top: 19px;
  padding-bottom: 19px;
  padding-left: 12px;
  padding-right: 9px;
}
.table td {
  border: none;
}
div.list-group-item.active {
  background-color: rgba(0, 0, 0, 0.03);
  color: #495057;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-color: rgba(0, 0, 0, 0.125);
}
.remove-tag {
  width: 20%;
  margin-left: 1%;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  font-size: 10px;
  border-radius: 4px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  cursor: default;
}
</style>
